import { render } from "./EventEdit-Component.vue?vue&type=template&id=4b86de8d&scoped=true"
import script from "./EventEdit-Component.vue?vue&type=script&lang=js"
export * from "./EventEdit-Component.vue?vue&type=script&lang=js"

import "./EventEdit-Component.vue?vue&type=style&index=0&id=4b86de8d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b86de8d"]])

export default __exports__